import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import { LogoFull } from '../../assets/icons';

import './ReLogin.scss';

const ReLoginOutlet = () => {
  return (
    <div className='relogin'>
      <div className='relogin__header'>
        <div className='header__logo'>
          <Link to={'/'}>
            <LogoFull color='#FFFFFF' verticalAlign='middle' />
          </Link>
        </div>
        <div className='header__note'>
          <span className='hide-mobile mr-4 fz-14'>Don’t have an account?</span>
          <Link to='/sign-upAuth' className='underline fz-14 fw-600 text-white'>
            Sign up
          </Link>
        </div>
      </div>
      <Outlet />
    </div>
  );
};

export default ReLoginOutlet;
